export default __webpack_public_path__ + "static/media/14-460x460.a7ae69e6.jpeg";